import { render, staticRenderFns } from "./ElementSizingOptionsComponent.vue?vue&type=template&id=04cefadc&"
import script from "./ElementSizingOptionsComponent.vue?vue&type=script&lang=js&"
export * from "./ElementSizingOptionsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports